import backgroundImage from '../../images/landing-bg-compressed.jpg';

export const BackgroundStyle = {
  backgroundImage: `url(${backgroundImage})`,
  height: '100%',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  boxShadow: 'inset 0 0 0 100vmax rgba(0, 0, 0, .4)',
  paddingTop: '70px',
};

export const ButtonGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridGap: '10px',
};
